// Reduced to 15 most predictive questions based on research validation
// Focus on Lack of Perseverance (primary predictor) + key DOSPERT and DD items

export interface PsychometricQuestion {
  id: string;
  section: 'upps_p' | 'dospert' | 'delay_discounting';
  subscale?: string;
  question: string;
  isReversed?: boolean;
  options: {
    value: number;
    label: string;
  }[];
}

export const reducedPsychometricQuestions: PsychometricQuestion[] = [
  // Lack of Perseverance (L) - 4 items - CRITICAL PREDICTOR
  {
    id: 'upps_l1',
    section: 'upps_p',
    subscale: 'lack_of_perseverance',
    question: 'Saya biasanya suka menyelesaikan sesuatu sampai tuntas.',
    isReversed: true,
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },
  {
    id: 'upps_l3',
    section: 'upps_p',
    subscale: 'lack_of_perseverance',
    question: 'Kalau sudah mulai mengerjakan sesuatu, saya jarang berhenti di tengah jalan.',
    isReversed: true,
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },
  {
    id: 'upps_l4',
    section: 'upps_p',
    subscale: 'lack_of_perseverance',
    question: 'Saya selalu menyelesaikan apa yang saya mulai.',
    isReversed: true,
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },

  // Negative Urgency (N) - 3 items
  {
    id: 'upps_n1',
    section: 'upps_p',
    subscale: 'negative_urgency',
    question: 'Ketika saya merasa sedih atau kecewa, saya sering melakukan hal-hal buruk',
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },
  {
    id: 'upps_n3',
    section: 'upps_p',
    subscale: 'negative_urgency',
    question: 'Saat kesal, saya sering bertindak tanpa berpikir terlebih dahulu.',
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },

  // Lack of Premeditation (P) - 2 items
  {
    id: 'upps_p1',
    section: 'upps_p',
    subscale: 'lack_of_premeditation',
    question: 'Saya biasanya berpikir dengan hati-hati sebelum bertindak.',
    isReversed: true,
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },
  {
    id: 'upps_p4',
    section: 'upps_p',
    subscale: 'lack_of_premeditation',
    question: 'Saya biasanya berpikir terlebih dahulu sebelum melakukan sesuatu.',
    isReversed: true,
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },

  // Sensation Seeking (S) - 2 items
  {
    id: 'upps_s1',
    section: 'upps_p',
    subscale: 'sensation_seeking',
    question: 'Saya cukup suka mengambil risiko.',
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },
  {
    id: 'upps_s4',
    section: 'upps_p',
    subscale: 'sensation_seeking',
    question: 'Saya menikmati sensasi saat ngebut naik motor di jalanan sepi.',
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },

  // Positive Urgency (PU) - 2 items
  {
    id: 'upps_pu1',
    section: 'upps_p',
    subscale: 'positive_urgency',
    question: 'Ketika saya sangat senang, saya cenderung melakukan hal-hal yang bisa menimbulkan masalah.',
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },
  {
    id: 'upps_pu2',
    section: 'upps_p',
    subscale: 'positive_urgency',
    question: 'Saat suasana hati sedang bagus, saya sering bertindak tanpa berpikir panjang.',
    options: [
      { value: 1, label: 'Sangat tidak setuju' },
      { value: 2, label: 'Tidak setuju' },
      { value: 3, label: 'Netral' },
      { value: 4, label: 'Setuju' },
      { value: 5, label: 'Sangat setuju' }
    ]
  },

  // DOSPERT Health/Safety - 2 most critical items
  {
    id: 'dospert_2',
    section: 'dospert',
    question: 'Menyepelekan penggunaan alat pelindung diri (APD) di tempat kerja meski ada potensi kecelakaan',
    options: [
      { value: 1, label: 'Sangat tidak mungkin' },
      { value: 2, label: 'Tidak mungkin' },
      { value: 3, label: 'Mungkin' },
      { value: 4, label: 'Sangat mungkin' },
      { value: 5, label: 'Pasti' }
    ]
  },
  {
    id: 'dospert_3',
    section: 'dospert',
    question: 'Berkendara melebihi batas kecepatan (ngebut) di jalan raya karena terburu-buru',
    options: [
      { value: 1, label: 'Sangat tidak mungkin' },
      { value: 2, label: 'Tidak mungkin' },
      { value: 3, label: 'Mungkin' },
      { value: 4, label: 'Sangat mungkin' },
      { value: 5, label: 'Pasti' }
    ]
  },

  // Delay Discounting - 3 items with visual comparison
  {
    id: 'dd_1',
    section: 'delay_discounting',
    question: 'Pilih mana yang kamu lebih suka:',
    options: [
      { value: 1, label: 'Rp 100.000 hari ini' },
      { value: 0, label: 'Rp 120.000 minggu depan' }
    ]
  },
  {
    id: 'dd_2',
    section: 'delay_discounting',
    question: 'Pilih mana yang kamu lebih suka:',
    options: [
      { value: 1, label: 'Rp 200.000 hari ini' },
      { value: 0, label: 'Rp 280.000 bulan depan' }
    ]
  },
  {
    id: 'dd_4',
    section: 'delay_discounting',
    question: 'Pilih mana yang kamu lebih suka:',
    options: [
      { value: 1, label: 'Rp 1.000.000 hari ini' },
      { value: 0, label: 'Rp 2.000.000 dalam 6 bulan' }
    ]
  }
];

// Calculate subscale scores (same logic as full version)
export const calculatePsychometricProfile = (answers: Record<string, number>) => {
  const uppsScores = {
    lack_of_perseverance: 0,
    negative_urgency: 0,
    positive_urgency: 0,
    lack_of_premeditation: 0,
    sensation_seeking: 0
  };

  const uppsCount = {
    lack_of_perseverance: 0,
    negative_urgency: 0,
    positive_urgency: 0,
    lack_of_premeditation: 0,
    sensation_seeking: 0
  };

  // Calculate UPPS-P subscales
  reducedPsychometricQuestions.filter(q => q.section === 'upps_p').forEach(question => {
    const answer = answers[question.id];
    if (answer && question.subscale) {
      let score = answer;
      if (question.isReversed) {
        score = 6 - answer;
      }
      uppsScores[question.subscale as keyof typeof uppsScores] += score;
      uppsCount[question.subscale as keyof typeof uppsCount]++;
    }
  });

  // Normalize UPPS-P scores to 0-1
  Object.keys(uppsScores).forEach(key => {
    const subscale = key as keyof typeof uppsScores;
    if (uppsCount[subscale] > 0) {
      uppsScores[subscale] = (uppsScores[subscale] / uppsCount[subscale] - 1) / 4;
    }
  });

  // Calculate DOSPERT Health/Safety
  let dospertSum = 0;
  let dospertCount = 0;
  reducedPsychometricQuestions.filter(q => q.section === 'dospert').forEach(question => {
    const answer = answers[question.id];
    if (answer) {
      dospertSum += answer;
      dospertCount++;
    }
  });
  const dospertScore = dospertCount > 0 ? (dospertSum / dospertCount - 1) / 4 : 0;

  // Calculate Delay Discounting
  let ddSum = 0;
  let ddCount = 0;
  reducedPsychometricQuestions.filter(q => q.section === 'delay_discounting').forEach(question => {
    const answer = answers[question.id];
    if (answer !== undefined) {
      ddSum += answer;
      ddCount++;
    }
  });
  const delayDiscountingK = ddCount > 0 ? ddSum / ddCount : 0;

  return {
    upps_p: uppsScores,
    dospert_health_safety: dospertScore,
    delay_discounting_k: delayDiscountingK,
    assessment_date: new Date().toISOString(),
    assessment_version: '1.1-reduced'
  };
};
